// items

const state = {
	items: [],
	item: {},
	refItems: {},
	cfgLists: [],
	file: {},
	progress: 0,
	
};

export default state;